import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams } from "@angular/http";
import { Angular2TokenService } from 'angular2-token'
import { Observable } from "rxjs/Observable";
import { Workshop } from "@models/workshop";
import { WorkshopAbsence } from "@models/workshop-absence";

export interface WorkshopsRolloverParams {
  from_term_id: number,
  to_term_id: number,
}

@Injectable()
export class WorkshopService {

  private workshopsUrl: string = 'workshops';
  private workshopsAbsenceUrl: string = 'workshop_absences';

  constructor(
    private http: Angular2TokenService,
  ) {}

  index(termId: number): Observable<Workshop[]> {
    const searchParams: URLSearchParams = new URLSearchParams()
    const options: any = { search: searchParams }

    searchParams.set("termId", termId.toString())

    return this.http.get(this.workshopsUrl, options)
      .map((res: Response) => res.json().map((w: any) => Workshop.clone(w)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(workshop: Workshop): Observable<Workshop> {
    return this.http.put(`${this.workshopsUrl}/${workshop.id}`, workshop.serializeForRails())
      .map((res: Response) => Workshop.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  createWorkshopAbsence(wa: WorkshopAbsence): Observable<WorkshopAbsence> {
    return this.http.post(this.workshopsAbsenceUrl, wa.serializeForRails())
      .map((res: Response) => WorkshopAbsence.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  deleteWorkshopAbsence(wa: WorkshopAbsence): Observable<any> {
    return this.http.delete(`${this.workshopsAbsenceUrl}/${wa.id}`)
      .map((res: Response) => res.json())
      .catch((error: Response) => Observable.throw(error.json()))
  }

  rollover(params: WorkshopsRolloverParams) {
    return this.http.get(`${this.workshopsUrl}/rollover/${params.from_term_id}/${params.to_term_id}`)
      .mapTo(true)
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/workshop.ts